<div class="draw-options symbol-editor" *ngIf="layerSymbol">
    <div *ngIf="markerSymbol">

        <div class="clearfix legendWideControlGroup">
            <label class="pull-left">Apply color to entire layer:</label>
            <input type="checkbox" class="pull-right checkbox"
                [(ngModel)]="applyColorToEntireLayer" (change)="applyColorToEntireLayerCheckboxChange()">
        </div>

        <div class="clearfix legendWideControlGroup" *ngIf="applyColorToEntireLayer">
            <label class="pull-left" (click)="layerColorPicker.showColorPicker = !layerColorPicker.showColorPicker">Layer Color:</label>
            <mc-color-picker-ng #layerColorPicker
                class="color-swatch right"  
                [color]="symbolColor"
                (colorChange)="updateColorFromPicker($event)">
            </mc-color-picker-ng>
            <a class="right cancel-button" *ngIf="!esriLayer || !(esriLayer.mapcoreProps.color === null || esriLayer.mapcoreProps.color === originalColor)" (click)="cancelColorChange('layerColor')">Cancel</a>
        </div>

        <div class="clearfix legendWideControlGroup" *ngIf="!applyColorToEntireLayer">
            <label class="pull-left" (click)="colorPicker.showColorPicker = !colorPicker.showColorPicker">Point Color:</label>
            <mc-color-picker-ng #colorPicker 
                class="color-swatch right"
                [color]="symbolColor" 
                (colorChange)="updateColorFromPicker($event)">
            </mc-color-picker-ng>
            <a class="right cancel-button" *ngIf="symbolColor !== originalColor" (click)="cancelColorChange()">Cancel</a>
        </div>

        <div class="clearfix legendWideControlGroup" *ngIf="!applyColorToEntireLayer">
            <label class="pull-left" (click)="outlineColorPicker.showColorPicker = !outlineColorPicker.showColorPicker">Outline Color:</label>
            <mc-color-picker-ng #outlineColorPicker 
                class="color-swatch right"
                [color]="outlineColor" 
                (colorChange)="updateColorFromPicker($event, 'outlineColor')">
            </mc-color-picker-ng>
            <a class="right cancel-button" *ngIf="outlineColor !== originalOutlineColor" (click)="cancelColorChange('outlineColor')">Cancel</a>
        </div>

        <div class="clearfix legendWideControlGroup">
            <label class="pull-left">Point Style:</label>
            <select class="pull-right" [(ngModel)]="pointStyle">
                <option [ngValue]="style" *ngFor="let style of pointSymbolOptions.pointStyles">{{ style.name }}</option>
            </select>

            <span class="pull-right svg-style-preview" style="margin: 7px 10px 0 0; line-height: 0;"
                *ngIf="layerSymbol.type !== 'simple-picture' && pointStyle && pointStyle.path">
                <svg id="change-tool-svg-preview" height="30" width="30" preserveAspectRatio="none">
                    <path id="draw-tool-point-path" [attr.d]="pointStyle.path" d="M0 0"></path>
                    <circle *ngIf="pointStyle.value === 'circle'" cx="15" cy="15" r="10" stroke="black"
                        stroke-width="1" fill="black" />
                    <rect *ngIf="pointStyle.value === 'square'" width="25" height="25"
                        style="fill: rgb(0,0,0); stroke-width: 1; stroke: rgb(0,0,0)" />
                </svg>
            </span>
        </div>

        <div class="clearfix legendWideControlGroup">
            <label class="pull-left">Point Size: </label>
            <select class="pull-right" [(ngModel)]="pointSize">
                <option [value]="s" *ngFor="let s of sizeOptions">{{ s }}</option>
            </select>
        </div>
    </div>

    <div *ngIf="pictureSymbol">
        <img [src]="pictureSymbol.url" style="max-width:40px;" />
        <div class="clearfix legendWideControlGroup">
            <label class="pull-left">Url:</label>
            <input type="text" class="pull-right" [(ngModel)]="pictureUrl" placeholder="Enter Url " />
        </div>
    </div>
    <br />
</div>
